export default "__VITE_ASSET__Cew6CxQ5__"